import { useMemo } from 'react'
import { ROLES } from '../../constants/roles'
import { useCurrentSelf } from './useCurrentSelf'

const getStoredRole = () => (typeof window !== 'undefined' ? localStorage.getItem('role') ?? '' : '')
const getStoredAdminView = () => (typeof window !== 'undefined' ? localStorage.getItem('is_admin') === 'true' : false)
export function useRole() {
  const { data: currentSelf, isPending } = useCurrentSelf()

  const backendRole = currentSelf?.authUser?.role ?? getStoredRole()
  const backendIsAdminCapable = Boolean(currentSelf?.authUser?.is_admin ?? getStoredAdminView())
  const chatbotMode = (currentSelf?.authUser?.chatbot_mode ?? (getStoredAdminView() ? 'admin' : 'user')) === 'admin'
    ? 'admin'
    : 'user'
  const isAdmin = backendIsAdminCapable && chatbotMode === 'admin'
  const role = isAdmin ? (backendRole || 'user') : 'user'
  const isUserMode = !isAdmin

  // False only while the backend answer is still in flight and every value above
  // is coming from the localStorage fallback. Callers that gate access on the
  // role have to wait for this, or they decide on a stale or missing value.
  const isRoleResolved = !isPending

  return useMemo(() => ({
    role,
    isRoleResolved,
    isAdmin,
    isSuperAdmin: role === ROLES.SUPER_ADMIN,
    isOrgAdmin: role === ROLES.ORG_ADMIN,
    isFinance: role === ROLES.FINANCE,
    isTeamLeader: role === ROLES.TEAM_LEADER,
    isUserMode,
    backendRole,
    backendIsAdminCapable,
    chatbotMode,
  }), [backendIsAdminCapable, backendRole, chatbotMode, isAdmin, isRoleResolved, isUserMode, role])
}
